export const procedureOutcomeCodes = [
  { code: "385669000", display: "Successful" },
  { code: "385671000", display: "Unsuccessful" },
  { code: "385670004", display: "Partially successful" },
];

export const procedureStatusCodes = [
  { code: "preparation", display: "Preparation" },
  { code: "in-progress", display: "In Progress" },
  { code: "not-done", display: "Not Done" },
  { code: "on-hold", display: "On Hold" },
  { code: "stopped", display: "Stopped" },
  { code: "completed", display: "Completed" },
  { code: "entered-in-error", display: "Entered in Error" },
  { code: "unknown", display: "Unknown" },
];

/** Canonical cath / interventional cardiology catalog (SNOMED). */
export const cardiacCatheterizationProcedures = [
  { snomedCID: "41976001", snomedFSN: "Cardiac catheterization (procedure)" },
  {
    snomedCID: "232967006",
    snomedFSN: "Left heart catheterization (procedure)",
  },
  {
    snomedCID: "67629009",
    snomedFSN: "Right heart catheterization (procedure)",
  },
  { snomedCID: "230960002", snomedFSN: "Coronary angiography (procedure)" },
  {
    snomedCID: "415070008",
    snomedFSN: "Percutaneous coronary intervention (procedure)",
  },
  {
    snomedCID: "36969009",
    snomedFSN: "Diagnostic cardiac catheterization (procedure)",
  },
  {
    snomedCID: "233158000",
    snomedFSN:
      "Percutaneous transluminal balloon angioplasty of coronary artery (procedure)",
  },
];

// TODO: find correct codes
export const procedureUsedTypes = [
  { code: "225708008", display: "IV Access (Gauge #)" },
  { code: "428311008", display: "Intraosseous Access" },
  { code: "232722000", display: "Chest Compressions" },
  { code: "40617009", display: "Endotracheal Intubation" },
  { code: "426362005", display: "Bag-Valve-Mask (BVM) Ventilation" },
  { code: "232674004", display: "Laryngeal Mask Airway (LMA) Placement" },
  { code: "30243000", display: "Chest Tube Placement" },
  { code: "232643001", display: "Needle Thoracostomy" },
  { code: "9042006", display: "Pericardiocentesis" },
  { code: "429500007", display: "Transcutaneous Pacing" },
  { code: "17436001", display: "Transvenous Pacing" },
  {
    code: "386336001",
    display: "Central Venous Catheter (CVP) Line Placement",
  },
  { code: "425447009", display: "Arterial Line Placement" },
  { code: "386802000", display: "Vagal Maneuvers" },
  { code: "225310000", display: "Electrocardiogram (ECG)" },
  { code: "429644000", display: "Defibrillation" },
  { code: "32485007", display: "Cardioversion" },
];

// TODO: find correct codes
export const defibrillationOutcomes = [
  { code: "427393009", display: "Normal Sinus Rhythm (NSR)" },
  {
    code: "111288001",
    display: "Ventricular Fibrillation (VF)",
  },
  {
    code: "204384007",
    display: "Pulseless Ventricular Tachycardia (VT)",
  },
  { code: "25079004", display: "Asystole" },
  {
    code: "75766006",
    display: "Pulseless Electrical Activity (PEA)",
  },
  { code: "49436004", display: "Atrial Fibrillation (AFib)" },
  { code: "195080001", display: "Atrial Flutter" },
  { code: "29320008", display: "Idioventricular Rhythm (IVR)" },
  { code: "427 Bradycardia", display: "Bradycardia" },
  {
    code: "81898007",
    display: "Accelerated Idioventricular Rhythm (AIVR)",
  },
  { code: "29369002", display: "Junctional Rhythm" },
  {
    code: "11157007",
    display: "Ventricular Tachycardia with a Pulse (VT with Pulse)",
  },
];
